import { render, staticRenderFns } from "./passage.vue?vue&type=template&id=39419628&scoped=true&"
import script from "./passage.vue?vue&type=script&lang=js&"
export * from "./passage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39419628",
  null
  
)

export default component.exports